export default __webpack_public_path__ + "static/media/boy.e43400d5.png";